import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Globals } from '../../globals';
import { filterOutputs } from '../../helpers';
import { NetworkDevice } from './networkdevices.interfaces';

@Injectable({
  providedIn: 'root',
})
export class NetworkdevicesService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);


  /**
   * Get network device by id
   * @param id Network device id
   */
  getNetworkDevice(id: number): Observable<NetworkDevice> {
    const url = `${this.globals.apiRoot}/jwtnetworkdevices/${id}`;
    return this.http.get<NetworkDevice>(url);
  }

  /**
   * Get network device api key by id
   * @param id Network device id
   */
  getNetworkDeviceApiKey(id: number): Observable<string> {
    const url = `${this.globals.apiRoot}/jwtnetworkdevices/${id}/apikey`;
    return this.http.get<string>(url);
  }

  /**
   * Get all network devices for a device
   * @param id Device id
   */
  getNetworkDevicesForDevice(id: number): Observable<NetworkDevice[]> {
    const url = `${this.globals.apiRoot}/jwtdevices/${id}/networkdevice`;
    return this.http.get<NetworkDevice[]>(url);
  }

  /**
   * update a networkdevice
   * @param networkDevice The network device you want to update with the properties as you need them to be
   */
  updateNetworkDevice(networkDevice: NetworkDevice): Observable<void> {
    const url = `${this.globals.apiRoot}/jwtnetworkdevices/${networkDevice.id}`;
    return this.http.put<void>(url, networkDevice);
  }

  /******************* Outputs **************************/

  /**
   * get all device details and outputs for the Device id
   */
  getNetworkDeviceWithFunctionblocks(id: number): Observable<NetworkDevice> {
    const url = `${this.globals.apiRoot}/jwtnetworkdevices/${id}/functionblocks`;
    return this.http.get<NetworkDevice>(url).pipe(map(filterOutputs));
  }

  /**
   * get the serialNumber and id from the network device, the parent device and the audio outputs
   */
  getNetworkDeviceForAudio(
    id: number,
    audioLinkId?: number,
  ): Observable<NetworkDevice> {
    let url = `${this.globals.apiRoot}/jwtnetworkdevices/${id}/audio`;
    if (audioLinkId !== undefined) url = `${url}/${audioLinkId}`;

    // Do not filter outputs because audiocontrol is needed!
    return this.http.get<NetworkDevice>(url);
  }

  deleteNetworkDevice(id: number): Observable<void> {
    const url = `${this.globals.apiRoot}/jwtnetworkdevices/${id}`;
    return this.http.delete<void>(url);
  }
}
